import { Fragment, useEffect, useState, } from "react";
import { Modal, Table } from "react-bootstrap";
import { connect } from "react-redux";
import { getConvenio } from "../../../../redux/Sections/Convenios/actions";
import { formatCapital } from "../../../../utils/utils";
import { formatCuotasPlan } from "./utils";

const ModalTable = ({ convenioId, show, handleClose, getConvenio, data, loading }) => {
  const [deudas, setDeudas] = useState([]);
  const [monto, setMonto] = useState("");
  const [honorarios, setHonorarios] = useState("");

  useEffect(() => {
    getConvenio(convenioId);

    return () => {
      setDeudas([]);
      setMonto("");
      setHonorarios("");
    };
  }, [convenioId]);

  useEffect(() => {
    return () => {
      setDeudas([]);
      setMonto("");
      setHonorarios("");
    };
  }, [data]);


  useEffect(() => {
    if (data?.cuotas_plan) {
      setDeudas(formatCuotasPlan(data?.cuotas_plan));
    }
  }, [data]);

  useEffect(() => {
    if (data?.planes) {
      let planes = JSON.parse(data.planes);

      let total = planes.reduce((prev, current) => {
        return +prev + +current.monto;
      }, 0);

      if (total) {
        setMonto(total);
        setHonorarios(total * (+data.estporc || 1));
      }
    }
  }, [data]);


  return (
    <Modal
      animation={false}
      show={!loading && show}
      onHide={handleClose}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Ver Convenio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover>
          <tbody>
            <tr>
              <td>DNI del firmante</td>
              <td>{data?.frm_dni}</td>
            </tr>
            <tr>
              <td>Apellido y Nombre del firmante</td>
              <td>{data?.frm_nombre}</td>
            </tr>
            <tr>
              <td>Dirección del firmante</td>
              <td>{data?.frm_dir}</td>
            </tr>
            <tr>
              <td>Localidad del firmante</td>
              <td>{data?.frm_loc}</td>
            </tr>
            <tr>
              <td>Teléfono del firmante</td>
              <td>{data?.frm_tel}</td>
            </tr>
            <tr>
              <td>Celular del firmante</td>
              <td>{data?.frm_cel}</td>
            </tr>
            <tr>
              <td>E-Mail del firmante</td>
              <td>{data?.frm_email}</td>
            </tr>
            <tr>
              <td>Carácter del firmante</td>
              <td>{data?.firma_caracter_nombre}</td>
            </tr>
            <tr>
              <td>Fecha de la firma</td>
              <td>{data?.format_confirma}</td>
            </tr>
            <tr>
              <td>Estado</td>
              <td>{data?.estado_nombre}</td>
            </tr>
            <tr>
              <td>Resumen Deuda</td>
              <td>
                <Table striped bordered hover>
                  <tbody>
                    {data?.cuotas_plan && deudas.map((e) => {
                      return (
                        <Fragment key={`${e.recurso}${e.imponible}`}>
                          <tr className="mt-1">
                            <td>Recuso</td>
                            <td>Imponible</td>
                            <td>Estado</td>
                          </tr>
                          <tr>
                            <td>{e.recurso}</td>
                            <td>{e.imponible}</td>
                            <td>{e.estado}</td>
                          </tr>
                          <tr>
                            <td colSpan={3}>Alcance del Plan</td>
                          </tr>
                          {e.deudas.map((d) => {
                            return (
                              <tr key={`${e.imponible}${d.anio}`}>
                                <td colSpan={3}>{d.anio}: {d.cuotas?.length ? d.cuotas.sort((a,b) => a - b).map((r, i) => r ? r + `${i === (d.cuotas?.length - 1) ? "" : ", "}` : null) : ""}</td>
                              </tr>
                            );
                          })}
                        </Fragment>

                      );
                    })}
                  </tbody>
                </Table>
              </td>
            </tr>
            <tr>
              <td>Monto</td>
              <td>{monto ? `$ ${formatCapital(monto)}` : ""}</td>
            </tr>
            <tr>
              <td>Honorarios s/Deuda</td>
              <td>{honorarios ? `$ ${formatCapital(honorarios)}` : ""}</td>
            </tr>
            <tr>
              <td>Gasto Fijo</td>
              <td>{data?.estgstfijo ? `$ ${data?.estgstfijo}` : ""}</td>
            </tr>
            <tr>
              <td>Total Honorarios</td>
              <td>{honorarios ? `$ ${formatCapital((+honorarios + +data?.estgstfijo))}` : ""}</td>
            </tr>
            <tr>
              <td>Forma de pago</td>
              <td>{data?.frmpg_nombre}</td>
            </tr>
            {data?.frmpg_nombre === "En Cuotas" ? <tr>
              <td>Cuotas Pago Profesional</td>
              <td>{data?.cuotaspago}</td>
            </tr> : null}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};


const mapStateToProps = (state) => {
  return {
    data: state.dashboard.convenio,
    loading: state.dashboard.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConvenio: (id) => dispatch(getConvenio(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalTable);